import { render } from "./sectioni.vue?vue&type=template&id=01f57936"
import script from "./sectioni.vue?vue&type=script&lang=js"
export * from "./sectioni.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__